/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metric } from './Metric';
import {
    MetricFromJSON,
    MetricFromJSONTyped,
    MetricToJSON,
    MetricToJSONTyped,
} from './Metric';

/**
 * 
 * @export
 * @interface BusinessReportOrderSourcesNetSalesResponse
 */
export interface BusinessReportOrderSourcesNetSalesResponse {
    /**
     * 
     * @type {Array<Metric>}
     * @memberof BusinessReportOrderSourcesNetSalesResponse
     */
    data: Array<Metric>;
}

/**
 * Check if a given object implements the BusinessReportOrderSourcesNetSalesResponse interface.
 */
export function instanceOfBusinessReportOrderSourcesNetSalesResponse(value: object): value is BusinessReportOrderSourcesNetSalesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportOrderSourcesNetSalesResponseFromJSON(json: any): BusinessReportOrderSourcesNetSalesResponse {
    return BusinessReportOrderSourcesNetSalesResponseFromJSONTyped(json, false);
}

export function BusinessReportOrderSourcesNetSalesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportOrderSourcesNetSalesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MetricFromJSON)),
    };
}

export function BusinessReportOrderSourcesNetSalesResponseToJSON(json: any): BusinessReportOrderSourcesNetSalesResponse {
    return BusinessReportOrderSourcesNetSalesResponseToJSONTyped(json, false);
}

export function BusinessReportOrderSourcesNetSalesResponseToJSONTyped(value?: BusinessReportOrderSourcesNetSalesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MetricToJSON)),
    };
}

